$(document).ready(function() {
	const carga = (el) => {
		el.addClass("cargado");
	};

	$(window).on("scroll", () => {
		var $maxScroll = $(window).height() + 100;
		var $maxScale = 1.5;
		var $x = $(window).scrollTop() / 6000 + 1;
		if ($(window).scrollTop() > $maxScroll) $x = $maxScale;
		$(".hero .background").css({
			transform: "scale(" + $x + "," + $x + ")",
		});

		if (
			$(window).scrollTop() >=
				$("#bloque-bienvenida .caracteristicas").offset().top -
					$(window).height() / 2 &&
			!$("#bloque-bienvenida .caracteristicas").hasClass("cargado")
		) {
			carga($("#bloque-bienvenida .caracteristicas"));
			$("#bloque-bienvenida .caracteristicas .container").slideDown();
		}

		if (
			$(window).scrollTop() >=
				$(".caracteristicas").offset().top - $(window).height() / 2 &&
			!$(".caracteristicas").hasClass("cargado")
		) {
			carga($(".caracteristicas"));
		}

		if (
			$(window).scrollTop() >=
			$(".disenio").offset().top - $(window).height() / 2
		) {
			$(".disenio .contenido").slideDown();
		}

		$(".parallax").paroller();
	});

	$("header").slideDown(() => {
		$(".hero .container").fadeIn();
	});
});

require("../modal_promocion");
